import type { DeleteCheckResponse, ProfileFieldsResponse } from "@repo/shared/types";
import { get } from "@/lib/api/_client";

const BASE = "/internal/custom-fields";

/**
 * Fields for the client profile card (QL-199): active fields with "Show in
 * profile" visibility — NOT the list-visible set that /active serves.
 */
export function getProfileFields(): Promise<ProfileFieldsResponse> {
  return get(`${BASE}/profile`);
}

/** QL-168 — asked when Delete is clicked, before the confirmation opens. */
export function checkDelete(id: string): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${id}/delete-check`);
}
